import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type CreditCardRows = {
  label: string;
  id: vp.CreditCardInfoId;
  required: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  date?: boolean;
  placeholder?: string;
  security?: boolean;
};

export const buildCreditCardInfoRows = (): CreditCardRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'CreditCardForm' });
  return [
    {
      label: `${t('name')}`,
      id: vp.CreditCardInfoId.FullName,
      required: true,
      preset: 'text',
    },
    {
      label: `${t('cardNumber')}`,
      id: vp.CreditCardInfoId.CardNumber,
      required: true,
      preset: 'creditCard',
      security: true,
    },
  ];
};

export const buildCreditCardInfoCodeRows = (): CreditCardRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'CreditCardForm' });
  return [
    {
      label: `${t('exp')}`,
      id: vp.CreditCardInfoId.ExpirationDate,
      required: true,
      preset: 'date',
      date: true,
      placeholder: 'MM/YY',
    },
    {
      label: `${t('CVV')}`,
      id: vp.CreditCardInfoId.CVV,
      required: true,
      preset: 'number',
      security: true,
    },
  ];
};
